import React from "react";

export default function MainSlider(){
    return(
        <>
        <div className="mainSlider-container">
      {/* Text Content */}
      <div className="slider-content">
        <h1>
        Empowering Your Business with  <br />
          <span>Seamless IT Solutions.</span>
        </h1>
        {/* <button className="slider-button">
          FIND YOUR SOLUTION <span>&rarr;</span>
        </button> */}
      </div>
      {/* Background Image */}
      <div className="slider-bg"></div>
    </div>
        </>
    )
}